import { getLocalApi } from './localApi';
import apiConfig from 'app/api/apiConfig.json';
import { getSelectedDivisionId } from 'app/shared/division/selectedDivisionStorage';


export async function getAccommodationRoomsByAccommodationId(
  accommodationId: string,
  divisionId?: number
): Promise<any[]> {
  const localApi = await getLocalApi();
  const divId = divisionId ?? getSelectedDivisionId();

  const url = apiConfig.accommodation_room_get_all
    .replace('{divisionId}', String(divId))
    .replace('{accommodationId}', encodeURIComponent(accommodationId));

  const resp = await localApi.call(url, 'GET', null);
  if (!resp?.ok) {
    let text = '';
    try { text = await resp.text(); } catch {}
    throw new Error(`Failed to load rooms (${resp?.status}): ${text}`);
  }

  let data: any = null;
  try { data = await resp.json(); } catch {}

  const list = Array.isArray(data) ? data : data?.items ?? data?.data ?? [];
  return list ?? [];
}
export async function getAccommodationRoomById(
  accommodationRoomId: string,
  divisionId?: number
): Promise<any> {
  const localApi = await getLocalApi();
  const divId = divisionId ?? getSelectedDivisionId();


  const url = apiConfig.accommodation_room_get_by_id
    .replace('{divisionId}', String(divId))
    .replace('{accommodationRoomId}', encodeURIComponent(accommodationRoomId));

  const resp = await localApi.call(url, 'GET', null);
  if (!resp?.ok) {
    let text = '';
    try { text = await resp.text(); } catch {}
    throw new Error(`Failed to load room (${resp?.status}): ${text}`);
  }
  try { return await resp.json(); } catch { return null; }
}